interface HeadlineProps {
  title?: string
  highlight?: string
  paragraph?: string
}

export function Headline({ title, highlight, paragraph }: HeadlineProps) {
  return (
    <>
      <h1 className='font-serif animate-slidein300 opacity-0 text-balance text-4xl font-medium tracking-tight text-dw-black sm:text-[54px] leading-[1.2] font-semibold '>
        {title} <span className='text-dw-gold'>{highlight}</span>
      </h1>
      <p className='animate-slidein500 opacity-0 mt-8 text-pretty text-m font-medium text-gray-600 sm:text-xl/8'>
        {paragraph}
      </p>
    </>
  )
}
